import ResourceService from './resource.service'

class ServiceService extends ResourceService {
  static get resource() {
    return 'service'
  }
}

export default ServiceService
